import React from 'react';
import PropTypes from 'prop-types';

import { MLoader } from './';

export default class MLargeFileUpload extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			fileName: '',
			isUploading: props.isUploading,
		};

		this.bindHandles();
	}
	componentDidMount() {
		this.initDrop();
		this.initDragOver();
	}

	componentWillReceiveProps(props) {
		for (const key in this.state) {
			if (key in props && props[key] !== this.state[key]) {
				this.setState({ [key]: props[key] });
			}
		}
	}

	bindHandles() {
		this.handleChange = this.handleChange.bind(this);
	}

	initDragOver() {// eslint-disable-line
		document.querySelector('body').addEventListener('dragover', (ev) => {
			ev.preventDefault();
		});
	}
	initDrop() {
		document.querySelector('body').addEventListener('drop', (ev) => {
			ev.preventDefault();
			document.querySelector(`#${this.props.id}`).files = ev.dataTransfer.files;
			this.setState({ fileName: ev.dataTransfer.files[0].name });
		});
	}

	handleChange(event) {
		this.props.onChange(event.target.files);
	}

	render() {
		let value = this.state.fileName ? `uploaded: ${this.state.fileName}` : this.props.placeholder;

		if (this.state.isUploading) {
			value = <MLoader />;
		}

		return (
			<label htmlFor={this.props.id} className={`m-large-file-upload ${this.props.className}`}>
				{value}
				<input id={this.props.id} type="file" onChange={this.handleChange} accept=".po" />
			</label>
		);
	}
}

MLargeFileUpload.propTypes = {
	id: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	isUploading: PropTypes.bool,
	className: PropTypes.string,
	onChange: PropTypes.func,
};

MLargeFileUpload.defaultProps = {
	placeholder: '',
	isUploading: false,
	className: '',
	onChange: undefined,
};



// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.large-file-upload.js